import { useState } from 'react';
import { Info } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export const InfoTooltipCard = ({ children }) => {
  const [open, setOpen] = useState(false);

  return (
    <TooltipProvider>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <div
            onClick={() => setOpen((prev) => !prev)} // toggle on tap/click
            className="inline-flex"
          >
            <Info className="w-4 h-4 text-[#6C6C7D] cursor-pointer" />
          </div>
        </TooltipTrigger>
        <TooltipContent className="text-black bg-white border border-black max-w-[400px] p-2 md:max-w-[250px]">
          <p>{children}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
